import { Injectable, signal } from '@angular/core';

import { TFolderItem } from '@core/interfaces/TFolderItem';
import { TSourceItem } from '@core/interfaces/TSourceItem';

export type SourcesTabKey = 'sources' | 'materials' | 'context';

@Injectable()
export class SourcesWorkspaceStateService {
  public readonly folders = signal<TFolderItem[]>([]);
  public readonly foldersLoading = signal(false);
  public readonly selectedFolder = signal<TFolderItem | null>(null);
  public readonly selectedSource = signal<TSourceItem | null>(null);
  public readonly selectedTab = signal<SourcesTabKey>('sources');
  public readonly isAnnotationsView = signal(false);
}
